<template>
  <PageTemplate :title="title" :loading="loading">
    <v-img
      v-if="img"
      :src="files + img + '?resize=1&w=960'"
      class="rounded bordered mt-6"
      max-height="540px"
      contain="contain"
    ></v-img>

    <div class="grey--text text--darken-2 mt-6 ck-content" v-html="text"></div>

    <div v-if="gallery.length" class="mt-10">
      <div class="text-center">
        <TitleWidget small>Galeria de Fotos</TitleWidget>

        <GalleryTemplate class="mt-6" :gallery="gallery" />
      </div>
    </div>
  </PageTemplate>
</template>

<script>
import PageTemplate from "./PageTemplate.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import GalleryTemplate from "../templates/GalleryTemplate.vue";

export default {
  props: {
    img: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    gallery: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PageTemplate,
    TitleWidget,
    GalleryTemplate,
  },
};
</script>
